import type { AxiosRequestConfig } from 'axios';
import api from './http';
import { openApiOperations, type OpenApiOperationKey } from './generated/openapi-contract';

type PathParams = Record<string, string | number>;
type QueryParams = Record<string, unknown>;

type OperationRequest = {
  path?: PathParams;
  query?: QueryParams;
  body?: unknown;
  config?: AxiosRequestConfig;
};

const operationMap = new Map(openApiOperations.map((operation) => [operation.key, operation]));

function buildPath(template: string, params: PathParams = {}): string {
  return template.replace(/\{([^}]+)\}/g, (_, key: string) => {
    const value = params[key];
    if (value === undefined || value === null) {
      throw new Error(`Missing path parameter "${key}" for ${template}`);
    }
    return encodeURIComponent(String(value));
  });
}

export async function requestOperation<TResponse = unknown>(
  operationKey: OpenApiOperationKey,
  request: OperationRequest = {}
): Promise<TResponse> {
  const operation = operationMap.get(operationKey);
  if (!operation) {
    throw new Error(`Unknown OpenAPI operation: ${operationKey}`);
  }

  const response = await api.request({
    method: operation.method,
    url: buildPath(operation.route, request.path),
    params: request.query,
    data: request.body,
    ...request.config,
  });

  return response.data as TResponse;
}

export function unwrapData<T>(response: { data: T }): T {
  return response.data;
}

export { api };
export { API_BASE_URL, apiUrl, isTrustedApiOrigin } from './config';
export type { OpenApiOperationKey };
